import { createModel } from "@rematch/core";
import { RootModel } from "../rootModel";

export interface IUserMenu {
  anchorOrigin: HTMLElement | null;
  showSignatureModal: boolean;
  signatureFile: File | null;
}

export const userMenu = createModel<RootModel>()({
  state: {
    anchorOrigin: null,
    showSignatureModal: false,
    signatureFile: null
  } as IUserMenu,
  reducers: {
    setAnchorOrigin(state, payload: HTMLElement | null) {
      return {
        ...state,
        anchorOrigin: payload
      };
    },
    setShowSignatureModal(state, payload: boolean) {
      return {
        ...state,
        showSignatureModal: payload
      };
    },
    setSignatureFile(state, payload: File | null) {
      return {
        ...state,
        signatureFile: payload
      };
    },
    cleanState(state) {
      return {
        ...state,
        anchorOrigin: null,
        showSignatureModal: false,
        signatureFile: null
      };
    }
  }
});
